"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIAGRAM_ORDER = exports.DiagramOrderDict = void 0;

var node_kind_1 = require("./entities/node-kind");

var DiagramOrderDict =
/** @class */
function () {
  function DiagramOrderDict() {
    this._order = {}; // Logic Scope

    this.setOrder(node_kind_1.NodeKind.initcont, 100);
    this.setOrder(node_kind_1.NodeKind.cont, 110);
    this.setOrder(node_kind_1.NodeKind.launcher, 200);
    this.setOrder(node_kind_1.NodeKind.vols, 230);
    this.setOrder(node_kind_1.NodeKind.hpa, 250);
    this.setOrder(node_kind_1.NodeKind.svcaccnt, 270);
    this.setOrder(node_kind_1.NodeKind.netpols, 280);
    this.setOrder(node_kind_1.NodeKind.service, 300);
    this.setOrder(node_kind_1.NodeKind.ingress, 320); // K8s Scope

    this.setOrder(node_kind_1.NodeKind.version, 100);
    this.setOrder(node_kind_1.NodeKind.api, 200);
  }

  DiagramOrderDict.prototype.setOrder = function (key, value) {
    this._order[key] = value;
  };

  DiagramOrderDict.prototype.get = function (kind) {
    var value = this._order[kind];

    if (value) {
      return value;
    }

    return 500;
  };

  return DiagramOrderDict;
}();

exports.DiagramOrderDict = DiagramOrderDict;
exports.DIAGRAM_ORDER = new DiagramOrderDict();